export default __webpack_public_path__ + "static/media/logo2.4f7b8f4a.png";